import { IndPhrase } from "@shared/models/cat.model";
import { IssuesFactory } from "../issues.factory";
import { EmbeddedObjectAnnotation, EmbeddedObjectAnnotationDto } from "@shared/models/embedded-object-annotation";
import { RevRule } from "@shared/models/rev.model";
import { DrawerDetails } from "@shared/models/common";


export class FairBalanceIssueDto {
    issueId: number;
    explanation: string;
    recommendations: string
    category: string;
    checkType: string;
    relatedPhraseIds: number[] | null;
    relatedPhraseTxts: string[] = []; 
    embeddedObjectAnnotation: EmbeddedObjectAnnotationDto | null;
}

export abstract class FairBalanceIssue {

    phraseId: number;
    issueId: number;
    explanation: string;
    recommendations: string;
    category: string;
    checkType: string;
    visibleViewActions: boolean = true;
    icon: string;
    tooltip: string;
    constructor(
        issueId: number,
        explanation: string,
        recommendations: string,
        category: string,
        checkType: string,
        icon: string,
        tooltip: string
    ) {
        
        this.issueId = issueId;
        this.explanation = explanation;
        this.recommendations = recommendations;
        this.category = category;
        this.checkType = checkType;
        this.icon = icon;
        this.tooltip = tooltip;
    }

    abstract view(): {type: string; data: EmbeddedObjectAnnotation | DrawerDetails};
    remove(phrase?: IndPhrase | RevRule) {
        
        if (phrase) {
            phrase.consistencyIssuesToUpdate.is_ref_consistent_anchor_update_only = false;
        }
        let anchorsToUpdate = phrase?.consistencyIssuesToUpdate || null;
        anchorsToUpdate?.remove.phrase_fair_balance_analysis_results.push({
            issue_id: this.issueId
        });
    }


}

export class FairBalanceIssueStandalone extends FairBalanceIssue {

    relatedPhraseIds: number[];
    relatedPhraseTxts: string[] = []; 
    
    constructor(
        issueId: number,
        explanation: string,
        recommendations: string,
        category: string,
        checkType: string,
        icon: string,
        tooltip: string,
        relatedPhraseIds: number[] | null = null,
        relatedPhraseTxts: string[] = []
     ) {
        
        super(issueId, explanation, recommendations, category, checkType, icon, tooltip);
        this.setRelatedPhraseIds(relatedPhraseIds);
        this.setReleatedPhraseTxts(relatedPhraseTxts);        
    }

    setRelatedPhraseIds(phraseIds: number[] | null) {  
        
        this.relatedPhraseIds = phraseIds;
        this.visibleViewActions = true;
        if (this.relatedPhraseIds == null) {
            this.visibleViewActions = false;
        }
    }

    setReleatedPhraseTxts(phrases: string[]) {

        this.relatedPhraseTxts = phrases;
    }

    view(): {type: string; data: EmbeddedObjectAnnotation | DrawerDetails} {

        //create object for drawer
        // initialize with all properties to be displayed
        let drawerDetails: DrawerDetails = new DrawerDetails();
        drawerDetails.isImage = false;
        drawerDetails.phraseTxt = this.relatedPhraseTxts.join(', ');
        console.log("related phrases txts: ", this.relatedPhraseTxts);


        return { type: 'FAIR_BALANCE_ISSUE_STANDALONE', data: drawerDetails };
    }
 
    remove(phrase?: IndPhrase | RevRule) {
        
        // continue
        super.remove(phrase);

    }


}


export class FairBalanceIssueReference extends FairBalanceIssue {

    embeddedObjectAnnotation: EmbeddedObjectAnnotation;

    constructor(issueId: number, explanation: string,
        recommendations: string, category: string, checkType: string,
        icon: string, tooltip: string,
        embeddedObjectAnnotation: EmbeddedObjectAnnotation,
        ) {


        super(issueId, explanation, recommendations, category, checkType, icon, tooltip);
        this.embeddedObjectAnnotation = embeddedObjectAnnotation;
    }

    view(): {type: string; data: EmbeddedObjectAnnotation | DrawerDetails} {
        // retrieve embeddedObjectAnnotation 
        //{ type: 'FAIR_BALANCE_ISSUE_REF', data: this.embeddedObjectAnnotation  }
        return { type: 'FAIR_BALANCE_ISSUE_REF', data: this.embeddedObjectAnnotation };
    }

    remove(phrase?: IndPhrase | RevRule) {
    
        super.remove(phrase);
    }

}